import { Link2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { isRemoteSession, useAccessSession } from "../../stores/accessSession";
import styles from "./NodeBadge.module.css";

/**
 * "Connected to <host> · <device>" — always visible in the sidebar when this
 * UI is served by a node on another machine (remote-node program N3: a
 * client must never wonder whose vault it is looking at). The host is the
 * page's own origin (that IS the node); the device is the name the token
 * carries, which the node reports on `/api/access/session`. Loopback renders
 * nothing — on the machine itself there is nothing to say.
 */
export function NodeBadge() {
	const { t } = useTranslation();
	const session = useAccessSession();
	if (!isRemoteSession(session)) return null;
	const host = typeof window === "undefined" ? "" : window.location.host;
	const parts = [t("nav.connectedTo", "Connected to {{host}}", { host })];
	if (session?.device) parts.push(session.device);
	if (session?.scope === "read_only") parts.push(t("nav.readOnly", "read-only"));
	return (
		<div className={styles.row} data-node-badge title={t("nav.connectedToTitle", "This AgntSpace runs on another machine; this device is its client. Manage devices there under Settings → Security → Remote access.")}>
			<Link2 size={11} aria-hidden />
			<span className={styles.text}>{parts.join(" · ")}</span>
		</div>
	);
}
